import type { FC } from 'react';

import { logout } from '@shared/auth';
import { logger } from '@luna/logger';
import { invalidateBankMessages, invalidateUnreadBankMessages } from '@shared/bank-messages-utils';
import { PageSpinner } from '@shared/core-ui-layout';
import { FocusPageOverlay } from '@shared/focus-page-ui';

import { useMustReadMessages } from './useMustReadMessages';
import { MustReadMessageFocusPage } from './MustReadMessageFocusPage';
import { trackAcknowledgeMessage, trackLogout } from './MustReadMessagesTrackingService';

export const MustReadMessages: FC = () => {
    const { mustReadMessages, isPending, refetch, markMessageAsRead } = useMustReadMessages();

    const showMustReadMessages = isPending || mustReadMessages.length > 0;

    if (!showMustReadMessages) {
        return null;
    }

    const handleLogout = (messageId: string) => {
        trackLogout(messageId);
        logout('manual');
    };

    const handleRefetch = () => {
        refetch().catch(logger.error);
    };

    const handleMessageAcknowledge = async (messageId: string) => {
        trackAcknowledgeMessage(messageId);
        await markMessageAsRead(messageId);

        invalidateBankMessages();
        invalidateUnreadBankMessages();
    };

    return (
        <FocusPageOverlay active={!isPending} data-cy="must-read-messages-overlay">
            {isPending && <PageSpinner />}
            {!isPending && (
                <MustReadMessageFocusPage
                    onRefetch={handleRefetch}
                    message={mustReadMessages[0]}
                    onLogout={handleLogout}
                    onMessageAcknowledge={handleMessageAcknowledge}
                />
            )}
        </FocusPageOverlay>
    );
};
